import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { FaCoffee, FaHome, FaPlane, FaLanguage, FaWifi, FaTripadvisor, FaInfo } from 'react-icons/fa';
import '../style.css';

function Services() {
  const services = [
    { icon: <FaCoffee />, title: "Complimentary", description: "Complimentary brewed coffee and fresh fruit during your Spanish classes." },
    { icon: <FaWifi />, title: "Free Internet", description: "Free use of the school internet and computers during your stay." },
    { icon: <FaPlane />, title: "Airport Pickup", description: "Hassle-free arrival and departure with our airport pickup service — $20 USD." },
    { icon: <FaLanguage />, title: "Cultural Exchange", description: "Practice your Spanish and help a Mexican improve their English while discovering local hidden gems." },
    { icon: <FaHome />, title: "Homestay", description: "Assistance to find the ideal accommodation for your stay in Tlaquepaque." },
    { icon: <FaTripadvisor />, title: "Activities", description: "We help you plan activities and excursions while you are here in México." },
    { icon: <FaInfo />, title: "Tourist Information", description: "Free tourist information in Spanish or English to make the most of your visit." },
  ];

  return (
    <div className="page-wrapper">
      <Helmet>
        <title>Services for Foreign Students | Culturlingua — Tlaquepaque</title>
        <meta name="description" content="Services for international students at Culturlingua: homestay, airport pickup, cultural activities, language exchange and more." />
      </Helmet>

      <div className="page-hero">
        <div className="section-tag">For International Students</div>
        <h1>Our Services</h1>
        <p>Everything you need for a smooth and enriching study experience in Mexico.</p>
      </div>

      <section style={{background:'var(--cream)', padding:'80px 48px'}}>
        <div style={{maxWidth:'1100px', margin:'0 auto'}}>
          <div style={{display:'grid', gridTemplateColumns:'repeat(auto-fill, minmax(280px, 1fr))', gap:'20px'}}>
            {services.map((s, i) => (
              <div key={i} style={{background:'white', borderRadius:'16px', padding:'32px', boxShadow:'0 2px 12px rgba(0,0,0,0.05)', transition:'transform 0.25s, box-shadow 0.25s'}}
                onMouseEnter={e => { e.currentTarget.style.transform='translateY(-4px)'; e.currentTarget.style.boxShadow='0 12px 32px rgba(0,0,0,0.1)'; }}
                onMouseLeave={e => { e.currentTarget.style.transform=''; e.currentTarget.style.boxShadow='0 2px 12px rgba(0,0,0,0.05)'; }}
              >
                <div style={{width:'48px', height:'48px', borderRadius:'12px', background:'rgba(59,111,224,0.1)', display:'flex', alignItems:'center', justifyContent:'center', color:'var(--blue)', fontSize:'1.4rem', marginBottom:'16px'}}>
                  {s.icon}
                </div>
                <h3 style={{fontFamily:'Fraunces, serif', fontWeight:'700', fontSize:'1.1rem', color:'var(--navy)', marginBottom:'10px'}}>{s.title}</h3>
                <p style={{color:'var(--muted)', fontSize:'0.875rem', lineHeight:'1.6'}}>{s.description}</p>
              </div>
            ))}
          </div>

          <div style={{background:'var(--navy)', borderRadius:'20px', padding:'48px', textAlign:'center', marginTop:'60px'}}>
            <h3 style={{fontFamily:'Fraunces, serif', fontSize:'1.8rem', color:'white', fontWeight:'900', marginBottom:'12px'}}>
              Ready to visit us?
            </h3>
            <p style={{color:'rgba(255,255,255,0.6)', marginBottom:'32px'}}>
              Contact us to plan your Spanish immersion experience in Tlaquepaque.
            </p>
            <div style={{display:'flex', gap:'16px', justifyContent:'center', flexWrap:'wrap'}}>
              <Link to="/contacto" className="btn-glow">Contact Us →</Link>
              <Link to="/OurLocation" className="btn-outline">Our Location</Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Services;
